@if (!loading) {
  <div class="history-item" [class.is-last]="isLastItem">
    <div class="item-status" [ngClass]="'status--' + item.status" [class.status-link]="!isSubItem && item.parentTransactionId">
      @if (!isSubItem && item.parentTransactionId && item.parentTransactionId !== currentTransactionId) {
        <a [routerLink]="['/', 'app', 'transactions', 'transactions', item.parentTransactionId]" class="item-status-link"></a>
      }
      @if (!isSubItem && item.parentTransactionId && item.parentTransactionId === currentTransactionId) {
        <a [routerLink]="['/', 'app', 'transactions', 'transactions', item.transactionId]" class="item-status-link"></a>
      }
    </div>
    <div class="date">{{ item.createdAt | dateFormat }}</div>
    <div class="message">{{ item.description }}</div>
    @if (item.parentTransactionId && !isSubItem) {
      <div class="parent-transaction-id">
        Linked Transaction ID:
        @if (item.parentTransactionId === currentTransactionId) {
          <a [routerLink]="['/', 'app', 'transactions', 'transactions', item.transactionId]" class="hover:text-primary">{{
            item.transactionId.split('-')[0] | uppercase
          }}</a>
        }
        @if (item.parentTransactionId !== currentTransactionId) {
          <a [routerLink]="['/', 'app', 'transactions', 'transactions', item.parentTransactionId]">{{
            item.parentTransactionId.split('-')[0] | uppercase
          }}</a>
        }
      </div>
    }
    <div class="author">Created by {{ item.employeeName }}</div>
    @if (!isSubItem && hasSubItems) {
      <button class="sub-items-toggle-btn" (click)="expandSubItems()">
        <rkt-icon [name]="isSubItemsExpanded ? 'chevron-up' : 'chevron-down'"></rkt-icon>
      </button>
    }
    @if (isSubItemsExpanded) {
      <div class="sub-items">
        @if (!isSubItemsLoading) {
          @if (!transactionHistorySubItems?.length) {
            <div class="history-item is-empty">No History found.</div>
          }
          @for (subItem of transactionHistorySubItems; track subItem; let last = $last) {
            <app-history-item [item]="subItem" [isLastItem]="last" [isSubItem]="true"></app-history-item>
          }
        } @else {
          <app-history-item [loading]="true" [isFirstItem]="true"></app-history-item>
          <app-history-item [loading]="true"></app-history-item>
          <app-history-item [loading]="true" [isLastItem]="true"></app-history-item>
        }
      </div>
    }
  </div>
}

@if (loading) {
  <div class="history-item loading" [class.is-last]="isLastItem">
    <div class="item-status status--loading"></div>
    <app-text-with-placeholder class="date" [showPlaceholder]="true"></app-text-with-placeholder>
    <app-text-with-placeholder class="placeholder-items message" [showPlaceholder]="true"></app-text-with-placeholder>
    <div class="placeholder-item-author author">
      <app-text-with-placeholder [showPlaceholder]="true"></app-text-with-placeholder>
    </div>
  </div>
}
